import React, { useEffect, useState } from "react";
import { object } from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import get from "lodash/get";

import Stories2AdWithLoadMore from "../../rows/Stories2AdWithLoadMore";
import NotLoggedInView from "../../rows/NotLoggedInView";

import { getCookie } from "../../utils/utils";
import { getCreStories } from "../../helper/api";
import { useDevice } from "../../utils/react-utils";

import "./fou-you.m.css";

function ForYouPage() {
  const creApi = useSelector((state) => get(state, ["qt", "config", "publisher-attributes", "cre_api"]));
  const [stories, setStories] = useState([]);
  const uId = getCookie("userID");
  const [loading, setLoading] = useState(!uId);
  const { name: deviceType } = useDevice();
  const dispatch = useDispatch();

  useEffect(() => {
    if (uId) {
      setLoading(true);
      dispatch({ type: "QT-PAGE_LOADING" });
      getCreStories(creApi, uId, 10)
        .then((res) => {
          const { data: { items = [] } = {} } = res || {};
          const stories = items.map(({ story } = {}) => story);
          setStories(stories);
        })
        .catch((err) => console.log(err))
        .finally(() => {
          dispatch({ type: "QT-PAGE_FINISHED_LOADING" });
          setLoading(false);
        });
    }
  }, []);

  return (
    <div styleName="base">
      <div styleName="title-wrapper">
        <h1 styleName="for-you-text">আপনার জন্য</h1>
      </div>
      {uId &&
        (stories.length ? (
          <Stories2AdWithLoadMore list={stories} />
        ) : (
          !loading && <div styleName="no-stories">No stories found !!</div>
        ))}

      {!uId && deviceType && (
        <div styleName="auth-button">
          <NotLoggedInView />
        </div>
      )}
    </div>
  );
}

ForYouPage.propTypes = {
  data: object,
};

export { ForYouPage };
